declare const require: any;
// This is a workaround to import json in TypeScript
export const version = require('../../package.json').version;